module.exports = new __parcel__URL__("LandInEditorBannerBackgroundDark.f8ccb0f3.svg").toString();